import { WhoWeAreContent } from './components/who-we-are-content/WhoWeAreContent';

export const WhoWeArePageAdmin = () => {
    return <WhoWeAreContent />;
};
